import API from '@/views/Fdc/Apis/'
import ModelGrid from '@/views/Fdc/Spc/SpcModelManager/Components/ModelGrid.vue'
import ModelRuleGrid from '@/views/Fdc/Spc/SpcModelManager/Components/ModelRuleGrid.vue'
import LotsModal from '@/views/Fdc/Spc/SpcModelManager/Components/LotsModal.vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import Dayjs from 'dayjs'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

export default {
  name: 'SpcModelManager',
  components: {
    /**
     * ModelGrid : 트리 조건에 해당하는 summary data plan의 SPC 데이터
     * ModelRuleGrid : 선택한 summary data plan의 SPC 룰 조건
     * LotsModel : Lot 선택 모달 팝업
     */
    'model-grid': ModelGrid,
    'model-rule-grid': ModelRuleGrid,
    'lots-modal': LotsModal
  },
  computed: {
    // 사용자 정보 조회
    ...mapGetters([
      'user',
      'authed'
    ])
  },
  methods: {
    /**
     * 노드 정보 저장(fdcEqpTree Event Trigger)
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * tree에서 선택된 값을 search버튼 모델 리스트 조회
     */
    searchModel () {
      this.chartData = []

      // modelGrid 컴포넌트의 searchModel로 연결
      this.$refs.modelGrid.searchModel(this.lotStepYn)

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )
    },
    /**
     * init chart
     * @param {*} chart
     */
    // initSpcModelChart (chart) {
    //   this.spcModelChart = chart

    //   // x축 기준 체크박스 설정에 따라 변경
    //   if (this.endDtYn === true) this.spcModelChart.bindingX = 'endDt'

    //   // chartdata 변경될 때 마다 전역변수 초기화
    //   this.spcModelChart.itemsSourceChanged.addHandler((s, e) => {
    //     if (s.itemsSource.itemCount === 0) {
    //       this.sigma = Math.round(this.selectedModelData.sigmaEstimate * 10000) / 10000.0
    //       this.uslVal = Math.round(this.selectedModelData.uslVal * 10000) / 10000.0
    //       this.uclVal = Math.round(this.selectedModelData.uclVal * 10000) / 10000.0
    //       this.meanVal = Math.round(this.selectedModelData.clVal * 10000) / 10000.0
    //       this.lclVal = Math.round(this.selectedModelData.lclVal * 10000) / 10000.0
    //       this.lslVal = Math.round(this.selectedModelData.lslVal * 10000) / 10000.0
    //       this.totalSampleCount = this.selectedModelData.valueCount
    //       this.targetMean = Math.round(this.selectedModelData.valueMean * 10000) / 10000.0
    //       this.upperSig2 = Math.round((this.meanVal + (+2 * this.selectedModelData.sigmaEstimate)) * 10000) / 10000.0
    //       this.upperSig1 = Math.round((this.meanVal + (+1 * this.selectedModelData.sigmaEstimate)) * 10000) / 10000.0
    //       this.lowerSig1 = Math.round((this.meanVal + (-1 * this.selectedModelData.sigmaEstimate)) * 10000) / 10000.0
    //       this.lowerSig2 = Math.round((this.meanVal + (-2 * this.selectedModelData.sigmaEstimate)) * 10000) / 10000.0
    //       this.sigUsl = 6
    //       this.sigUcl = 3
    //       this.sigLcl = 3
    //       this.sigLsl = 6
    //     } else {
    //       this.stdevVal = Math.round(this.stdevVal * 10000) / 10000.0
    //       this.sigma = Math.round(this.sigma * 10000) / 10000.0
    //       this.uslVal = Math.round(this.uslVal * 10000) / 10000.0
    //       this.uclVal = Math.round(this.uclVal * 10000) / 10000.0
    //       this.meanVal = Math.round(this.meanVal * 10000) / 10000.0
    //       this.lclVal = Math.round(this.lclVal * 10000) / 10000.0
    //       this.lslVal = Math.round(this.lslVal * 10000) / 10000.0
    //       this.upperSig2 = Math.round((this.meanVal + (+2 * this.sigma)) * 10000) / 10000.0
    //       this.upperSig1 = Math.round((this.meanVal + (+1 * this.sigma)) * 10000) / 10000.0
    //       this.lowerSig1 = Math.round((this.meanVal + (-1 * this.sigma)) * 10000) / 10000.0
    //       this.lowerSig2 = Math.round((this.meanVal + (-2 * this.sigma)) * 10000) / 10000.0
    //       this.totalSampleCount = this.chartData.length

    //       // summary 데이터 평균값
    //       let sum = 0.0
    //       for (let i = 0; i < this.chartData.length; i++) {
    //         sum += this.chartData[i].paramValue
    //       }

    //       this.targetMean = null
    //       if (this.chartData.length !== 0) {
    //         this.targetMean = Math.round((sum / this.chartData.length) * 10000) / 10000.0
    //       }

    //       // y축 범위 계산
    //       // var yValues = this.chartData.map(function (o) { return o.paramValue })
    //       // yValues.push(this.uslVal)
    //       // yValues.push(this.uclVal)
    //       // yValues.push(this.meanVal)
    //       // yValues.push(this.lclVal)
    //       // yValues.push(this.lslVal)
    //       // yValues.push(this.upperSig2)
    //       // yValues.push(this.lowerSig2)
    //       // this.drawChartArea(yValues)
    //       // Spec Line 출력
    //       // this.drawChartAnnotation()

    //       this.drawChart()
    //     }
    //   })
    // },
    /**
     * SPC Model Chart draw
     */
    drawChart () {
      var convertFloat = (value) => {
        return typeof value === 'string' ? parseFloat(value) : value
      }
      const uslVal = convertFloat(this.uslVal)
      const uclVal = convertFloat(this.uclVal)
      const meanVal = convertFloat(this.meanVal)
      const lclVal = convertFloat(this.lclVal)
      const lslVal = convertFloat(this.lslVal)

      const USL_SHAPE_KEY = { shapeKey: 'USL', shapeValue: uslVal, shapeColor: 'red' }
      const UCL_SHAPE_KEY = { shapeKey: 'UCL', shapeValue: uclVal, shapeColor: 'orange' }
      const LCL_SHAPE_KEY = { shapeKey: 'LCL', shapeValue: lclVal, shapeColor: 'orange' }
      const LSL_SHAPE_KEY = { shapeKey: 'LSL', shapeValue: lslVal, shapeColor: 'red' }
      const MEAN_SHAPE_KEY = { shapeKey: 'CL', shapeValue: meanVal }
      const specLineArr = [USL_SHAPE_KEY, UCL_SHAPE_KEY, LCL_SHAPE_KEY, LSL_SHAPE_KEY, MEAN_SHAPE_KEY]
      const nonZeroValues = specLineArr.filter(spec => spec.shapeValue !== 0)

      let traces = [
        {
          y: this.chartData.map(element => element.paramValue),
          text: this.chartData.map(element => { return { endDt: Dayjs(element.endDt).format('YYYY-MM-DD HH:mm:ss'), lotId: element.lotId, substId: element.substId, moduleId: element.moduleId, recipeId: element.recipeId, oocRuleList: element.oocRuleList } }),
          mode: 'markers',
          type: 'scatter',
          hovertemplate: '<b>Date</b>: %{text.endDt|%Y-%m-%d %H:%M:%S.%L}' +
            '<br><b>Lot Id</b>: %{text.lotId}' +
            '<br><b>SubStrate Id</b>: %{text.substId}' +
            '<br><b>Module Id</b>: %{text.moduleId}' +
            '<br><b>Recipe Id</b>: %{text.recipeId}' +
            '<br><b>Parameter Value</b>: %{y: .4f}',
          showlegend: false,
          name: ''
        },
        {
          // x: this.chartData.map(element => Dayjs(element.endDt, 'YYYY-MM-DD HH:mm:ss.SSS').toDate()),
          // x: this.chartData.map(element => element.x),
          y: this.chartData.map(element => element.ooc),
          text: this.chartData.map(element => { return { oocRuleList: element.oocRuleList } }),
          mode: 'markers',
          type: 'scatter',
          line: { color: 'red' },
          hovertemplate: '<b>Fault Rule No.</b>: %{text.oocRuleList}',
          showlegend: false,
          name: ''
        }
      ]

      let layout = {
        hovermode: 'x unified',
        xaxis: {
          zeroline: false,
          showspikes: true
        },
        yaxis: {
          zeroline: false,
          showspikes: true
        },
        legend: {
          orientation: 'h'
        },
        shapes: [
          // {
          //   _shapeKey: USL_SHAPE_KEY,
          //   type: 'line',
          //   xref: 'paper',
          //   x0: 0,
          //   x1: 1,
          //   yref: 'y',
          //   y0: uslVal,
          //   y1: uslVal,
          //   line: { color: 'red', width: 1 }
          // }, {
          //   _shapeKey: UCL_SHAPE_KEY,
          //   type: 'line',
          //   xref: 'paper',
          //   x0: 0,
          //   x1: 1,
          //   yref: 'y',
          //   y0: uclVal,
          //   y1: uclVal,
          //   line: { color: 'orange', width: 1 }
          // }, {
          //   _shapeKey: LCL_SHAPE_KEY,
          //   type: 'line',
          //   xref: 'paper',
          //   x0: 0,
          //   x1: 1,
          //   yref: 'y',
          //   y0: lclVal,
          //   y1: lclVal,
          //   line: { color: 'orange', width: 1 }
          // }, {
          //   _shapeKey: LSL_SHAPE_KEY,
          //   type: 'line',
          //   xref: 'paper',
          //   x0: 0,
          //   x1: 1,
          //   yref: 'y',
          //   y0: lslVal,
          //   y1: lslVal,
          //   line: { color: 'red', width: 1 }
          // }, {
          //   _shapeKey: MEAN_SHAPE_KEY,
          //   type: 'line',
          //   xref: 'paper',
          //   x0: 0,
          //   x1: 1,
          //   yref: 'y',
          //   y0: meanVal,
          //   y1: meanVal,
          //   line: { width: 1 }
          // }
        ],
        annotations: [
          // {
          //   _shapeKey: USL_SHAPE_KEY,
          //   xref: 'paper',
          //   x: 1,
          //   xanchor: 'left',
          //   yref: 'y',
          //   y: uslVal,
          //   text: 'USL: ' + uslVal,
          //   showarrow: false
          // }, {
          //   _shapeKey: UCL_SHAPE_KEY,
          //   xref: 'paper',
          //   x: 1,
          //   xanchor: 'left',
          //   yref: 'y',
          //   y: uclVal,
          //   text: 'UCL: ' + uclVal,
          //   showarrow: false
          // }, {
          //   _shapeKey: LCL_SHAPE_KEY,
          //   xref: 'paper',
          //   x: 1,
          //   xanchor: 'left',
          //   yref: 'y',
          //   y: lclVal,
          //   text: 'LCL: ' + lclVal,
          //   showarrow: false
          // }, {
          //   _shapeKey: LSL_SHAPE_KEY,
          //   xref: 'paper',
          //   x: 1,
          //   xanchor: 'left',
          //   yref: 'y',
          //   y: lslVal,
          //   text: 'LSL: ' + lslVal,
          //   showarrow: false
          // },
          // {
          //   _shapeKey: MEAN_SHAPE_KEY,
          //   xref: 'paper',
          //   x: 1,
          //   xanchor: 'left',
          //   yref: 'y',
          //   y: meanVal,
          //   text: 'CL: ' + meanVal,
          //   showarrow: false
          // }
        ]
      }

      const shapeDefaultObject = {
        type: 'line',
        xref: 'paper',
        x0: 0,
        x1: 1,
        yref: 'y',
        line: { width: 1 }
      }

      const annotationDefaultObject = {
        xref: 'paper',
        x: 1,
        xanchor: 'left',
        yref: 'y',
        showarrow: false
      }

      layout.shapes = this.initChartShape(shapeDefaultObject, nonZeroValues)
      layout.annotations = this.initChartAnnotation(annotationDefaultObject, nonZeroValues)

      if (this.endDtYn === true) {
        traces[0]['x'] = this.chartData.map(element => element.endDt)
        traces[1]['x'] = this.chartData.map(element => element.endDt)
        layout['xaxis']['type'] = 'date'
        layout['xaxis']['tickformat'] = '%Y-%m-%d %H:%M:%S'
      } else {
        traces[0]['x'] = this.chartData.map(element => element.x)
        traces[1]['x'] = this.chartData.map(element => element.x)
        layout['xaxis']['type'] = 'number'
        layout['xaxis']['tickformat'] = null
      }
      // sigma line Y/N
      if (this.sigmaLineYn === true) {
        if (this.upperSig2 !== 0) {
          layout.shapes.push({
            type: 'line',
            xref: 'paper',
            x0: 0,
            x1: 1,
            yref: 'y',
            y0: this.upperSig2,
            y1: this.upperSig2,
            line: { color: 'yellowgreen', width: 1 }
          })
          layout.annotations.push({
            xref: 'paper',
            x: 1,
            xanchor: 'left',
            yref: 'y',
            y: this.upperSig2,
            text: '+2 Sigma: ' + Math.round(this.upperSig2 * 10000) / 10000.0,
            showarrow: false
          })
        }
        if (this.upperSig1 !== 0) {
          layout.shapes.push({
            type: 'line',
            xref: 'paper',
            x0: 0,
            x1: 1,
            yref: 'y',
            y0: this.upperSig1,
            y1: this.upperSig1,
            line: { color: 'yellowgreen', width: 1 }
          })
          layout.annotations.push({
            xref: 'paper',
            x: 1,
            xanchor: 'left',
            yref: 'y',
            y: this.upperSig1,
            text: '+1 Sigma: ' + Math.round(this.upperSig1 * 10000) / 10000.0,
            showarrow: false
          })
        }
        if (this.lowerSig1 !== 0) {
          layout.shapes.push({
            type: 'line',
            xref: 'paper',
            x0: 0,
            x1: 1,
            yref: 'y',
            y0: this.lowerSig1,
            y1: this.lowerSig1,
            line: { color: 'yellowgreen', width: 1 }
          })
          layout.annotations.push({
            xref: 'paper',
            x: 1,
            xanchor: 'left',
            yref: 'y',
            y: this.lowerSig1,
            text: '-1 Sigma: ' + Math.round(this.lowerSig1 * 10000) / 10000.0,
            showarrow: false
          })
        }
        if (this.lowerSig2 !== 0) {
          layout.shapes.push({
            type: 'line',
            xref: 'paper',
            x0: 0,
            x1: 1,
            yref: 'y',
            y0: this.lowerSig2,
            y1: this.lowerSig2,
            line: { color: 'yellowgreen', width: 1 }
          })
          layout.annotations.push({
            xref: 'paper',
            x: 1,
            xanchor: 'left',
            yref: 'y',
            y: this.lowerSig2,
            text: '-2 Sigma: ' + Math.round(this.lowerSig2 * 10000) / 10000.0,
            showarrow: false
          })
        }
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true,
        edits: { shapePosition: true }
      }

      BriqueChart.newPlot('spcModelChart', traces, layout, config).then(() => {
        document.querySelector('#spcModelChart').on('plotly_relayout', (event) => {
          if (event.recursive) return
          let chart = document.querySelector('#spcModelChart')
          let shapes = chart.layout.shapes
          let annotations = chart.layout.annotations
          // shapes.forEach(shape => {
          //   shape.x0 = 0
          //   shape.x1 = 1
          // })
          // shapes[0].x0 = shapes[1].x0 = shapes[2].x0 = shapes[3].x0 = 0
          // shapes[0].x1 = shapes[1].x1 = shapes[2].x1 = shapes[3].x1 = 1
          // this.uslVal = shapes[0].y0 = shapes[0].y1 = annotations[0].y = Math.round(shapes[0].y1 * 10000) / 10000.0
          // this.uclVal = shapes[1].y0 = shapes[1].y1 = annotations[1].y = Math.round(shapes[1].y1 * 10000) / 10000.0
          // this.lclVal = shapes[2].y0 = shapes[2].y1 = annotations[2].y = Math.round(shapes[2].y1 * 10000) / 10000.0
          // this.lslVal = shapes[3].y0 = shapes[3].y1 = annotations[3].y = Math.round(shapes[3].y1 * 10000) / 10000.0
          // annotations[0].text = 'USL: ' + annotations[0].y
          // annotations[1].text = 'UCL: ' + annotations[1].y
          // annotations[2].text = 'LCL: ' + annotations[2].y
          // annotations[3].text = 'LSL: ' + annotations[3].y
          // shapes[4].x0 = 0
          // shapes[4].x1 = 1
          // shapes[4].y0 = shapes[4].y1 = annotations[4].y = this.meanVal
          BriqueChart.setYMinMax('spcModelChart', chart.data, chart.layout)
          BriqueChart.relayout('spcModelChart', { recursive: true, shapes, annotations })
        })
      })
    },
    /**
     * Return
     */
    initChartShape (defaultObject, specLines) {
      const shapeArr = specLines.map(spec => {
        return {
          ...defaultObject,
          y0: spec.shapeValue,
          y1: spec.shapeValue,
          line: { color: spec.shapeColor, width: 1 }
        }
      })
      return shapeArr
    },
    initChartAnnotation (defaultObject, specLines) {
      const annotationArr = specLines.map(spec => {
        return {
          ...defaultObject,
          y: spec.shapeValue,
          text: `${spec.shapeKey}: ${spec.shapeValue}`
        }
      })
      return annotationArr
    },
    /**
     * Checkbox 변화 감지 (Show Data, Show Sigma)
     */
    onClickCheckbox () {
      this.drawChart()
    },
    /**
     * Remove Outlier
     * Outlier 값에서 벗어난 param값 chartData에서 삭제
     */
    removeOutlier () {
      // Simulation data 초기화
      this.simulationData = []

      // chartData 데이터 비교하여 outlier 벗어난 값 splice로 삭제
      let i = this.chartData.length
      while (i--) {
        if (this.chartData[i]['paramValue'] > this.upperOutlier || this.chartData[i]['paramValue'] < this.lowerOutlier) {
          this.chartData.splice(i, 1)
        }
      }

      for (let i = 0; i < this.chartData.length; i++) { this.chartData[i]['x'] = i }

      // 총 건수
      this.totalSampleCount = this.chartData.length

      // 바뀐 raw data 저장
      this.simulationData = { rawData: [] }
      for (let i = 0; i < this.chartData.length; i++) {
        this.simulationData.rawData.push({
          lotId: this.chartData[i]['lotId'],
          substId: this.chartData[i]['substId'],
          x: this.chartData[i]['endDt'],
          y: this.chartData[i]['paramValue']
        })
      }

      // var yValues = this.chartData.map(function (o) { return o.paramValue })
      // yValues.push(this.uslVal)
      // yValues.push(this.uclVal)
      // yValues.push(this.meanVal)
      // yValues.push(this.lclVal)
      // yValues.push(this.lslVal)
      // yValues.push(this.upperSig2)
      // yValues.push(this.lowerSig2)
      // this.drawChartArea(yValues)

      // Spec Line 출력
      // this.drawChartAnnotation()

      // 차트 refresh
      // this.spcModelChart.collectionView.refresh()
      this.drawChart()

      // Toast message 출력
      this.$buefy.toast.open({
        message: this.$t('fdc.SPC.MESSAGE.OUTLIER_REMOVED'),
        // type: 'is-success', // 연두색 배경
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    },
    /**
     * AutoSpec Validation
     */
    isValidAutoSpec () {
      let self = this

      if (this.selectedModelData == null || !Object.keys(this.selectedModelData).length) {
        this.$dialog.alert({
          message: self.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Model']),
          scroll: 'keep'
        })
        return false
      }
      if (this.selectedLots == null || this.selectedLots.length < 1) {
        this.$dialog.alert({
          message: self.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Lots']),
          scroll: 'keep'
        })
        return false
      }
      if (this.chartData == null || !this.chartData.length) {
        this.$dialog.alert({
          message: self.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Chart Data']),
          scroll: 'keep'
        })
        return false
      }
      if (this.sigUsl <= this.sigUcl) {
        this.$dialog.alert({
          message: self.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Upper Sigma']),
          scroll: 'keep'
        })
        return false
      }
      if (this.sigLsl <= this.sigLcl) {
        this.$dialog.alert({
          message: self.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Lower Sigma']),
          scroll: 'keep'
        })
        return false
      }
      var isValid = function (that, sigma, name) {
        if (sigma == null || !sigma > 0) {
          that.$dialog.alert({
            message: that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [name + ' Sigma']),
            scroll: 'keep'
          })
          return false
        }
        if (sigma <= 0) {
          that.$dialog.alert({
            message: that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', [name + ' Sigma']),
            scroll: 'keep'
          })
          return false
        }
        return true
      }

      return !(!isValid(this, this.sigUsl, 'USL') ||
        !isValid(this, this.sigUcl, 'UCL') ||
        !isValid(this, this.sigLcl, 'LCL') ||
        !isValid(this, this.sigLsl, 'LSL'))
    },
    /**
     * AutoSpec 계산 API 호출
     */
    calcAutoSpec () {
      // 배열 초기화
      this.orgAutoSpecData = []
      this.chartData.map(data => {
        data['ooc'] = null
        data['oocRuleList'] = null
      })
      this.rawExcelData.map(data => { data['oocRuleList'] = null })

      // sigma 절대값 구하기
      this.sigUsl = Math.abs(this.sigUsl)
      this.sigUcl = Math.abs(this.sigUcl)
      this.sigLcl = Math.abs(this.sigLcl)
      this.sigLsl = Math.abs(this.sigLsl)

      // validatoin
      if (!this.isValidAutoSpec()) {
        return
      }

      // Auto Spec input parameters
      const payload = {
        rawData: [],
        weight: this.weight,
        sigUsl: this.sigUsl,
        sigUcl: this.sigUcl,
        sigLcl: this.sigLcl,
        sigLsl: this.sigLsl
      }

      // Raw data 저장
      this.chartData.map(data => payload.rawData.push(Number(data.paramValue)))

      API.Model.getSpcModelAutoSpec(payload).then(response => {
        if (response.status === 200) {
          this.orgAutoSpecData = response.data
          // 소수점 4번째 자리까지 반올림
          this.meanVal = Math.round(response.data.mean * 10000) / 10000.0
          this.stdevVal = Math.round(response.data.stdev * 10000) / 10000.0
          this.sigma = Math.round(response.data.sigma * 10000) / 10000.0
          this.uslVal = Math.round(response.data.usl * 10000) / 10000.0
          this.uclVal = Math.round(response.data.ucl * 10000) / 10000.0
          this.lclVal = Math.round(response.data.lcl * 10000) / 10000.0
          this.lslVal = Math.round(response.data.lsl * 10000) / 10000.0
          this.upperSig2 = Math.round((this.meanVal + (+2 * this.sigma)) * 10000) / 10000.0
          this.upperSig1 = Math.round((this.meanVal + (+1 * this.sigma)) * 10000) / 10000.0
          this.lowerSig1 = Math.round((this.meanVal + (-1 * this.sigma)) * 10000) / 10000.0
          this.lowerSig2 = Math.round((this.meanVal + (-2 * this.sigma)) * 10000) / 10000.0

          // Outlier 기본값은 USL, LSL
          this.upperOutlier = this.uslVal
          this.lowerOutlier = this.lslVal

          // y축 범위 계산
          // var yValues = this.chartData.map(function (o) { return o.paramValue })
          // yValues.push(this.uslVal)
          // yValues.push(this.uclVal)
          // yValues.push(this.meanVal)
          // yValues.push(this.lclVal)
          // yValues.push(this.lslVal)
          // yValues.push(this.upperSig2)
          // yValues.push(this.lowerSig2)
          // this.drawChartArea(yValues)

          // Spec Line 출력
          // this.drawChartAnnotation()

          // Chart refresh
          // self.spcModelChart.collectionView.refresh()
          this.drawChart()
        }
      })
    },
    /**
   * Simulation API 호출
   */
    calcSimulation () {
      let self = this

      let yRules = this.$refs.modelRuleGrid.getRules()

      // 배열 초기화
      this.chartData.map(data => {
        data['ooc'] = null
        data['oocRuleList'] = null
      })
      this.rawExcelData.map(data => { data['oocRuleList'] = null })
      // 우선 autospec 조건체크 함수 같이 쓰기
      if (!this.isValidAutoSpec()) {
        return
      }

      if (this.weight === null) {
        this.$dialog.alert('Weight를 입력하세요')
        return
      } else if (this.upperOutlier === null) {
        this.$dialog.alert('Upper Outlier를 입력하세요')
        return
      } else if (this.lowerOutlier === null) {
        this.$dialog.alert('Lower Outlier를 입력하세요')
        return
      }

      // sigma line Validation
      if (this.uslVal < this.uclVal) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Upper Sigma']))
        return
      }
      if (this.lclVal < this.lslVal) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Lower Sigma']))
        return
      }

      // Simulation input parameters
      const payload = {
        rawData: [],
        mean: this.meanVal,
        weight: this.weight,
        sigma: this.sigma,
        usl: this.uslVal,
        ucl: this.uclVal,
        lcl: this.lclVal,
        lsl: this.lslVal,
        rules: yRules
      }

      // x값은 endDt아닌 인덱스로 전달(int)
      for (let i = 0; i < this.chartData.length; i++) {
        payload.rawData.push({
          x: i, // 인덱스
          y: Number(this.chartData[i].paramValue),
          rules: this.selectedRules
        })
      }

      API.Model.runSpcModelSimulation(payload).then(response => {
        if (response.status === 200) {
          this.simulationData = response.data

          // raw데이터만 저장
          let tmpArr = response.data.rawData

          // raw data index(x값)로 정렬
          tmpArr.sort((a, b) => {
            return a.x < b.x ? -1 : a.x > b.x ? 1 : 0
          })

          // ooc Rule 조건 존재 하는 경우 y값 저장
          for (let i = 0; i < this.chartData.length; i++) {
            if (tmpArr[i].rules.length !== 0) {
              this.chartData[i]['ooc'] = Number(tmpArr[i].y)

              // Tooltip에 사용하기 위해 Fault Rule Number 스트링으로 저장
              let str = ''
              tmpArr[i].rules.map(data => {
                if (data !== null) str += data + ', ' // 쉼표와 공백으로 연결
              })
              this.chartData[i]['oocRuleList'] = str.trim().slice(0, -1)
              this.rawExcelData[i]['oocRuleList'] = str.trim().slice(0, -1)
            } else this.chartData[i]['ooc'] = null

            // tn_spc_model_calc 테이블에 데이터 저장할 때 사용하기 위해 simulation rawData에 simulation에 사용한 값 저장
            this.simulationData.rawData[i]['lotId'] = this.chartData[i]['lotId']
            this.simulationData.rawData[i]['x'] = this.chartData[i]['endDt']
            this.simulationData.rawData[i]['rules'] = tmpArr[i].rules
            this.simulationData.rawData[i]['substId'] = this.chartData[i]['substId']
          }

          // Toast Message
          this.$buefy.toast.open({
            message: 'Simulation Completed.',
            type: 'is-success',
            queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
          })

          // Chart refresh
          // self.spcModelChart.collectionView.refresh()
          self.drawChart()
        }
      })
    },
    /**
   * 차트 y축 영역 계산
   * 210528 plotly 적용하며 삭제
   */
    // drawChartArea (yValues) {
    //   if (yValues == null || !yValues.length) {
    //     return
    //   }
    //   let yMin = 0
    //   let yMax = 100
    //   let margin = 0
    //   yMax = Math.max(...yValues)
    //   yMin = Math.min(...yValues)
    //   margin = (yMax - yMin) * 0.2
    //   this.yMin = yMin - margin
    //   this.yMax = yMax + margin

    //   this.drawChart()

    //   // y축 범위 지정
    //   // this.spcModelChart.axisY.min = this.yMin
    //   // this.spcModelChart.axisY.max = this.yMax
    // },
    /**
   * Draw Chart Spec Limit Line
   * 210528 plotly 적용하며 삭제
   */
    // drawChartAnnotation () {
    //   var convertFloat = (value) => {
    //     return typeof value === 'string' ? parseFloat(value) : value
    //   }
    //   const uslVal = convertFloat(this.uslVal)
    //   const uclVal = convertFloat(this.uclVal)
    //   const meanVal = convertFloat(this.meanVal)
    //   const lclVal = convertFloat(this.lclVal)
    //   const lslVal = convertFloat(this.lslVal)
    //   const upperSig2 = convertFloat(this.upperSig2)
    //   const upperSig1 = convertFloat(this.upperSig1)
    //   const lowerSig1 = convertFloat(this.lowerSig1)
    //   const lowerSig2 = convertFloat(this.lowerSig2)
    //   // const textGap = 0.02
    //   var xValues = []

    //   if (this.endDtYn === true) this.chartData.map(data => xValues.push(data.endDt))
    //   else this.chartData.map(data => xValues.push(data.x))

    //   const xStartValue = Math.min(...xValues)
    //   const xEndVal = Math.max(...xValues)

    //   if (!this.annotations) {
    //     const slSty = { 'fill': 'rgba(227, 65, 96, .8)', 'stroke': 'rgba(227, 65, 96, .8)' }
    //     const clSty = { 'fill': 'rgba(236, 126, 48, .8)', 'stroke': 'rgba(236, 126, 48, .8)' }
    //     const meanSty = { 'fill': 'rgba(81, 109, 136, .8)', 'stroke': 'rgba(81, 109, 136, .8)' }
    //     const sigSty = { 'fill': 'rgba(32, 208, 191, .8)', 'stroke': 'rgba(32, 208, 191, .8)' }
    //     this.uslLine.style = slSty
    //     this.uslLine.name = 'USL'
    //     this.annotationItems.push(this.uslLine)
    //     // this.annotationItems.push(this.uslText)
    //     this.uclLine.style = clSty
    //     this.uclLine.name = 'UCL'
    //     this.annotationItems.push(this.uclLine)
    //     // this.annotationItems.push(this.uclText)
    //     this.mean.style = meanSty
    //     this.mean.name = 'CL'
    //     this.annotationItems.push(this.mean)
    //     // this.annotationItems.push(this.meanText)
    //     this.lclLine.style = clSty
    //     this.lclLine.name = 'LCL'
    //     this.annotationItems.push(this.lclLine)
    //     // this.annotationItems.push(this.lclText)
    //     this.lslLine.style = slSty
    //     this.lslLine.name = 'LSL'
    //     this.annotationItems.push(this.lslLine)
    //     // this.annotationItems.push(this.lslText)

    //     // sigma line 체크박스 여부에 따라 출력
    //     if (this.sigmaLineYn === true) {
    //       this.upperSig2Line.style = sigSty
    //       this.upperSig2Line.name = '+2 Sigma'
    //       this.annotationItems.push(this.upperSig2Line)
    //       this.annotationItems.push(this.upperSig2Text)

    //       this.upperSig1Line.style = sigSty
    //       this.upperSig1Line.name = '+1 Sigma'
    //       this.annotationItems.push(this.upperSig1Line)
    //       this.annotationItems.push(this.upperSig1Text)

    //       this.annotationItems.push(this.lowerSig1Text)
    //       this.lowerSig1Line.style = sigSty
    //       this.lowerSig1Line.name = '-1 Sigma'
    //       this.annotationItems.push(this.lowerSig1Line)

    //       this.lowerSig2Line.style = sigSty
    //       this.lowerSig2Line.name = '-2 Sigma'
    //       this.annotationItems.push(this.lowerSig2Line)
    //       this.annotationItems.push(this.lowerSig2Text)
    //     }

    //     // this.annotations = new EditableAnnotationLayer(this.spcModelChart, this.annotationItems)
    //     // this._bindEditableEvent()
    //   }
    //   for (let i = 0; i < this.annotations.items.length; i++) {
    //     var value; var name

    //     name = this.annotations.items[i].name
    //     switch (name) {
    //       case 'USL':
    //         value = uslVal
    //         break
    //       case 'UCL':
    //         value = uclVal
    //         break
    //       case 'CL':
    //         value = meanVal
    //         break
    //       case 'LCL':
    //         value = lclVal
    //         break
    //       case 'LSL':
    //         value = lslVal
    //         break
    //       case '+2 Sigma':
    //         value = upperSig2
    //         break
    //       case '+1 Sigma':
    //         value = upperSig1
    //         break
    //       case '-1 Sigma':
    //         value = lowerSig1
    //         break
    //       case '-2 Sigma':
    //         value = lowerSig2
    //         break
    //       default:
    //         value = 0
    //         break
    //     }
    //     this.annotations.items[i].start = { x: xStartValue, y: value }
    //     this.annotations.items[i].end = { x: xEndVal, y: value }
    //     this.annotations.items[i].content = name + ' : ' + (Math.round(value * 10000) / 10000.0)
    //   }
    // },
    /**
   * 저장 전 check
   */
    isValidSaveData () {
      if (this.chartData == null || !this.chartData.length) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Chart Data']))
        return false
      }

      var isValid = function (that, value, name) {
        if (value == null || value === '' || !value > 0) {
          that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [name]))
          return false
        }
        return true
      }

      return !(
        !isValid(this, this.uslVal, 'USL') ||
        !isValid(this, this.uclVal, 'UCL') ||
        !isValid(this, this.meanVal, 'CL') ||
        !isValid(this, this.lclVal, 'LCL') ||
        !isValid(this, this.lslVal, 'LSL')
      )
    },
    /**
   * 데이터 저장
   */
    async saveData () {
      let self = this

      // 우선 autospec 조건체크 함수 같이 쓰기
      if (!self.isValidAutoSpec()) {
        return
      }

      // Spec Line Validation
      if (this.uslVal < this.uclVal) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Upper Sigma']))
        return
      }
      if (this.lclVal < this.lslVal) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Lower Sigma']))
        return
      }
      const checkedRows = this.$refs.modelGrid.$refs.modelGrd.getCheckedRows()

      // Auto Spec만 하고 저장
      let payloadAuto = {
        dataList: [{
          fab: this.selectedModelData.fab,
          eqpId: this.selectedModelData.eqpId,
          moduleId: this.selectedModelData.moduleId,
          paramName: this.selectedModelData.paramName,
          recipeId: this.selectedModelData.recipeId,
          stepId: this.selectedModelData.stepId,
          smryType: this.selectedModelData.smryType,
          lotStepYn: this.selectedModelData.lotStepYn,
          useYn: this.selectedModelData.useYn,
          sigmaEstimate: this.sigma,
          clVal: this.meanVal,
          uslVal: this.uslVal,
          uclVal: this.uclVal,
          lclVal: this.lclVal,
          lslVal: this.lslVal,
          createUser: 'brique',
          modifyUser: 'brique'
        }]
      }

      // Simulation까지 하고 저장
      let payloadSimulation = {
        fab: this.selectedModelData.fab,
        eqpId: this.selectedModelData.eqpId,
        moduleId: this.selectedModelData.moduleId,
        paramName: this.selectedModelData.paramName,
        recipeId: this.selectedModelData.recipeId,
        stepId: this.selectedModelData.stepId,
        smryType: this.selectedModelData.smryType,
        lotStepYn: this.selectedModelData.lotStepYn,
        valueList: JSON.stringify(this.simulationData.rawData),
        valueCount: this.totalSampleCount,
        valueMean: this.meanVal,
        valueStd: this.stdevVal,
        estimateWeight: this.weight,
        upperOutlier: this.upperOutlier,
        lowerOutlier: this.lowerOutlier,
        createUser: 'brique',
        modifyUser: 'brique'
      }

      // 저장 확인 창
      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')

      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      this.$dialog.confirm({
        message: confirmMessage,
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          // Auto Spec만 하고 저장
          const responseData = await API.Model.saveSpcModels(payloadAuto)
          if (responseData != null && responseData.status === 200) {
            self.$refs.modelGrid.setLastestSelectedData(checkedRows[0])
          } else {
            this.$dialog.alert(failMessage)
          }

          // Simulation까지 하고 저장
          if (payloadSimulation.valueList !== null) {
            const responseData = await API.Model.saveSpcModelSimulation(payloadSimulation)
            if (responseData != null && responseData.status === 200) {
              this.$dialog.alert(successMessage)
              self.$refs.modelGrid.setLastestSelectedData(checkedRows[0])
              self.$refs.modelGrid.refreshModel()
            } else {
              this.$dialog.alert(failMessage)
            }
          } else {
            this.$dialog.alert(successMessage)
            self.$refs.modelGrid.setLastestSelectedData(checkedRows[0])
            self.$refs.modelGrid.refreshModel()
          }
        }
      })
    },
    /**
   * popup visible
   * @param {*} value
   */
    resetModalData (value) {
      this.selectLotsModal.visible = value
    },
    /**
   * select Lot modal 호출
   */
    showLotsModal () {
      // this.selectLotsModal.visible = true
      this.selectLotsModal.visible = this.selectedModelData !== null && Object.keys(this.selectedModelData).length > 0
      if (!this.selectLotsModal.visible) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Model']))
      }
    },
    /**
   * popup callback
   * @param {*} list
   * 선택한 LOT 목록으로 SUMMARY DATA 조회
   */
    applyLots (list) {
      let self = this
      this.orgAutoSpecData = []
      this.simulationData = []
      this.selectedLots = list

      // lot list input data
      const payload = {
        fabId: this.selectedModelData.fab,
        eqpId: this.selectedModelData.eqpId,
        moduleId: this.selectedModelData.moduleId,
        recipeId: this.selectedModelData.recipeId,
        lotList: this.selectedLots,
        stepList: [this.selectedModelData.stepId],
        paramName: this.selectedModelData.paramName,
        summaryTypeList: [this.selectedModelData.smryType]
      }

      API.Analysis.getSpcSummaryDatas(payload).then(response => {
        if (response) {
          // specline 존재 하는 경우 초기화
          if (this.annotations) {
            this.annotations.items.splice(0, this.annotations.items.length)
            this.annotations = null
            this.annotationItems = []
          }
          this.orgChartData = []
          this.chartData = []
          this.yMin = null
          this.yMax = null
          this.upperOutlier = this.uslVal
          this.lowerOutlier = this.lslVal
          this.orgChartData = response.datas

          // chartData endDt로 정렬 (시간순서)
          this.orgChartData.sort((a, b) => {
            return a.endDt < b.endDt ? -1 : a.endDt > b.endDt ? 1 : 0
          })

          for (let i = 0; i < this.orgChartData.length; i++) {
            if (!isNaN(Number(this.orgChartData[i]['paramValues']))) {
              this.chartData.push({
                x: i,
                fab: this.selectedModelData.fab,
                eqpId: this.selectedModelData.eqpId,
                moduleId: this.selectedModelData.moduleId,
                paramName: this.selectedModelData.paramName,
                recipeId: this.selectedModelData.recipeId,
                stepId: this.selectedModelData.stepId,
                smryType: this.selectedModelData.smryType,
                endDt: new Date(this.orgChartData[i]['endDt']),
                lotId: this.orgChartData[i]['lotId'],
                paramValue: Number(this.orgChartData[i]['paramValues']),
                substId: this.orgChartData[i]['substId'],
                ooc: null,
                oocRuleList: ''
              })
            }
          }

          this.rawExcelData = this.chartData

          // 바뀐 raw data 저장
          this.simulationData = { rawData: [] }
          for (let i = 0; i < this.chartData.length; i++) {
            this.simulationData.rawData.push({
              lotId: this.chartData[i]['lotId'],
              substId: this.chartData[i]['substId'],
              x: this.chartData[i]['endDt'],
              y: this.chartData[i]['paramValue']
            })
          }

          // y축 범위 재지정
          // var yValues = this.chartData.map(function (o) { return o.paramValue })
          // this.drawChartArea(yValues)

          // 총 데이터 summary 건수
          this.totalSampleCount = this.chartData.length

          // summary 데이터 평균값
          let sum = 0.0
          for (let i = 0; i < this.chartData.length; i++) {
            sum += this.chartData[i].paramValue
          }

          this.targetMean = null
          if (this.chartData.length !== 0) {
            this.targetMean = Math.round((sum / this.chartData.length) * 10000) / 10000.0
          }

          // this.drawChartAnnotation()
          self.drawChart()
        }
      })
    },
    /**
   * Model에서 선택한 Row 설정
   * @param {*} row
   */
    // ModelGrid 값 바뀔때마다 chart 초기화
    setModelProps (row) {
      this.selectedLots = []
      this.selectedModelData = row
      this.selectedModelRuleData = []
      this.chartData = []
      this.orgChartData = []
      this.orgAutoSpecData = []
      // this.initSpcModelChart(this.spcModelChart)f
      this.yMax = null
      this.ymin = null
      this.upperOutlier = null
      this.lowerOutlier = null
      let jsonValueList = []

      // FIXME: row 클릭이 아닌 체크박스 클릭으로 2개 이상이 선택될 경우 row가 null로 들어오는 문제 임시 처리
      // console.log(row)
      if (!this.selectedModelData) return

      // Chart 영역 Header에 검색 조건 출력
      this.breadcrumbs = this.selectedModelData.paramAlias +
        ' / ' + this.selectedModelData.smryType +
        ' / ' + this.selectedModelData.recipeId +
        ' / Step ' + this.selectedModelData.stepId

      // tn_spc_model_calc valueList json으로 불러와서 파싱
      jsonValueList = JSON.parse(this.selectedModelData.valueList)

      // chartData endDt로 정렬 (시간순서)
      if (jsonValueList !== null) {
        jsonValueList.sort((a, b) => {
          return a.x < b.x ? -1 : a.x > b.x ? 1 : 0
        })

        for (let i = 0; i < jsonValueList.length; i++) {
          this.chartData.push({
            x: i,
            fab: this.selectedModelData.fab,
            eqpId: this.selectedModelData.eqpId,
            moduleId: this.selectedModelData.moduleId,
            paramName: this.selectedModelData.paramName,
            recipeId: this.selectedModelData.recipeId,
            stepId: this.selectedModelData.stepId,
            smryType: this.selectedModelData.smryType,
            endDt: new Date(jsonValueList[i]['x']),
            paramValue: Number(jsonValueList[i]['y']),
            substId: jsonValueList[i]['substId'],
            lotId: jsonValueList[i]['lotId'],
            ooc: null,
            oocRuleList: jsonValueList[i]['rules']
          })

          // Chart Data 생성

          // Fault Rules 존재하는 경우 ooc에 저장하여 빨간 점으로 표시
          if (jsonValueList[i]['rules']) {
            if (jsonValueList[i]['rules'].length > 0) { this.chartData[i]['ooc'] = jsonValueList[i]['y'] }
          }

          // 선택한 lot 목록
          this.selectedLots.push(jsonValueList[i]['lotId'])
        }
      }

      // 바뀐 raw data 저장
      this.simulationData = { rawData: [] }
      for (let i = 0; i < this.chartData.length; i++) {
        this.simulationData.rawData.push({
          lotId: this.chartData[i]['lotId'],
          substId: this.chartData[i]['substId'],
          x: this.chartData[i]['endDt'],
          y: this.chartData[i]['paramValue']
        })
      }

      // Grid와 Excel export 저장할 데이터에 저장
      this.rawExcelData = this.formatGridData(this.chartData)

      // this.stdevVal = Math.round(this.selectedModelData.valueStd * 10000) / 10000.0
      this.sigma = Math.round(this.selectedModelData.sigmaEstimate * 10000) / 10000.0
      this.uslVal = Math.round(this.selectedModelData.uslVal * 10000) / 10000.0
      this.uclVal = Math.round(this.selectedModelData.uclVal * 10000) / 10000.0
      this.meanVal = Math.round(this.selectedModelData.clVal * 10000) / 10000.0
      this.lclVal = Math.round(this.selectedModelData.lclVal * 10000) / 10000.0
      this.lslVal = Math.round(this.selectedModelData.lslVal * 10000) / 10000.0
      this.totalSampleCount = this.selectedModelData.valueCount
      this.upperOutlier = Math.round(this.selectedModelData.upperOutlier * 10000) / 10000.0
      this.lowerOutlier = Math.round(this.selectedModelData.lowerOutlier * 10000) / 10000.0
      this.upperSig2 = Math.round((this.selectedModelData.clVal + (+2 * this.sigma)) * 10000) / 10000.0
      this.upperSig1 = Math.round((this.selectedModelData.clVal + (+1 * this.sigma)) * 10000) / 10000.0
      this.lowerSig1 = Math.round((this.selectedModelData.clVal + (-1 * this.sigma)) * 10000) / 10000.0
      this.lowerSig2 = Math.round((this.selectedModelData.clVal + (-2 * this.sigma)) * 10000) / 10000.0

      for (let i = 0; i < this.chartData.length; i++) {
        this.rawExcelData[i]['paramAlias'] = this.selectedModelData.paramAlias
        this.rawExcelData[i]['uslVal'] = this.uslVal
        this.rawExcelData[i]['uclVal'] = this.uclVal
        this.rawExcelData[i]['clVal'] = this.meanVal
        this.rawExcelData[i]['lclVal'] = this.lclVal
        this.rawExcelData[i]['lslVal'] = this.lslVal
      }

      // y축 범위 재지정
      // var yValues = this.chartData.map(function (o) { return o.paramValue })
      // yValues.push(this.upperSig2)
      // yValues.push(this.lowerSig2)
      // this.drawChartArea(yValues)
      // this.drawChartAnnotation()

      this.drawChart()
    },
    /**
   * Model에서 선택한 Row 설정
   * @param {*} row
   */
    setModelRuleProps (row) {
      this.selectedModelRuleData = row
    },

    // tooltip
    tooltipContent (hti) {
      let item = hti.item

      let endDt = Dayjs(item.endDt).format('YYYY-MM-DD HH:mm:ss')

      let tooltipText = `<b>Date</b>: ${endDt}</br>
        <b>Lot Id</b>: ${item.lotId}</br>
        <b>SubStrate Id</b>: ${item.lotId}</br>
        <b>Module Id</b>: ${item.moduleId}</br>
        <b>Parameter Value</b>: ${Math.round(item.paramValue * 10000) / 10000.0}</br>
        <b>Recipe Id</b>: ${item.recipeId}</br>`

      if (item.oocRuleList) {
        if (item.oocRuleList.length > 0) tooltipText += `<b>Fault Rule No.</b>: ${item.oocRuleList}</br>`
      }

      return tooltipText
    },

    // 툴팁에 사용할 날짜 계산
    formatDate (date) {
      String.prototype.string = function (len) { var s = ''; var i = 0; while (i++ < len) { s += this } return s }
      String.prototype.zf = function (len) { return '0'.string(len - this.length) + this }
      let dateTimeFmt = (date.getMonth() + 1) + '/' + date.getDate().toString().zf(2) + ' ' + date.getHours().toString().zf(2) + ':' + date.getMinutes().toString().zf(2) + ':' + date.getSeconds().toString().zf(2)
      return dateTimeFmt
    },
    // Model data 조회 여부에 따라 컴포넌트 disable 결정
    hasSelectedModelData () {
      if (this.selectedModelData === null) {
        return false
      } else if (Object.keys(this.selectedModelData).length === 0) {
        return false
      } else if (this.selectedModelData.briqueGridCud && this.selectedModelData.briqueGridCud === 'C') {
      // } else if (this.selectedModelData._status.added) {
        return false
      } else {
        return true
      }
    },

    // Autospec data 조회 여부에 따라 컴포넌트 disable 결정
    hasAutoSpecData () {
      if (this.orgAutoSpecData === null && this.chartData === null) {
        return false
      } else if (Object.keys(this.orgAutoSpecData).length === 0 && this.chartData.length === 0) {
        return false
      } else {
        return true
      }
    },

    valueChange (params) {
      this.upperSig2 = Number(this.meanVal) + (+2 * this.sigma)
      this.upperSig1 = Number(this.meanVal) + (+1 * this.sigma)
      this.lowerSig1 = Number(this.meanVal) + (-1 * this.sigma)
      this.lowerSig2 = Number(this.meanVal) + (-2 * this.sigma)

      // test 필요
      // var yValues = this.chartData.map(function (o) { return o.paramValue })
      // yValues.push(this.uslVal)
      // yValues.push(this.uclVal)
      // yValues.push(this.meanVal)
      // yValues.push(this.lclVal)
      // yValues.push(this.lslVal)
      // yValues.push(this.upperSig2)
      // yValues.push(this.lowerSig2)
      // this.drawChartArea(yValues)

      // this.drawChartAnnotation()
      this.drawChart()
    },

    onSigmaInputBlur (event) {
      if (event.relatedTarget) {
        if (event.relatedTarget.id === 'autoSpecButton') {
          this.calcAutoSpec()
        }
      }
    },

    refreshChart () {
      this.setModelProps(this.selectedModelData)
    },

    async setModelUseYn () {
      let self = this
      // Auto Spec만 하고 저장
      let payload = {
        dataList: [{
          fab: this.selectedModelData.fab,
          eqpId: this.selectedModelData.eqpId,
          moduleId: this.selectedModelData.moduleId,
          paramName: this.selectedModelData.paramName,
          recipeId: this.selectedModelData.recipeId,
          stepId: this.selectedModelData.stepId,
          smryType: this.selectedModelData.smryType,
          lotStepYn: this.selectedModelData.lotStepYn,
          useYn: 'N',
          sigmaEstimate: this.selectedModelData.sigmaEstimate,
          clVal: this.selectedModelData.clVal,
          uslVal: this.selectedModelData.uslVal,
          uclVal: this.selectedModelData.uclVal,
          lclVal: this.selectedModelData.lclVal,
          lslVal: this.selectedModelData.lslVal,
          createUser: 'brique',
          modifyUser: 'brique'
        }]
      }

      const responseData = await API.Model.saveSpcModels(payload)
      if (responseData != null && responseData.status === 200) {
        self.$buefy.toast.open({
          message: self.$t('fdc.SPC.MESSAGE.SPC_RULE_UNUSED_SAVE'),
          // type: 'is-success',
          queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
        })

        self.$refs.modelGrid.refreshModel()
      } else {
        self.$dialog.alert(failMessage)
      }
    },

    /**
   * Export Excel
   * 조회된 data를 Excel 파일로 다운로드 합니다.
   */
    exportCSV () {
      this.$refs.rawDataGrid.gridApi.exportDataAsCsv({
        fileName: 'SPC Model Data.csv'
      })
    },

    // // TAB 변경 시 마다 INDEX 가져오기(체크박스/EXPORT 버튼 출력 여부에 사용)
    // onChangeTab (index) {
    //   this.selectedTab = index
    // },

    // ======================= Chart관련 Method Start =========================
    /**
   * 이벤트 바인딩
   * chart annotation event 설정
   */
    // _bindEditableEvent () {
    //   var self = this.annotations
    //   self._hostMouseDown = this._onHostMouseDown.bind(self)
    //   self._hostMouseMove = this._onHostMouseMove.bind(self)
    //   self._hostMouseUp = this._onHostMouseUp.bind(self)
    //   self._hostMouseLeave = this._onHostMouseLeave.bind(self)
    //   this.toggleDragEventBinding()
    // },
    /**
   * 리스너 등록
   * @param {Boolean} bind 리스너 적용 여부 (true = add, false = remove)
   */
    // toggleDragEventBinding (bind = true) {
    //   var self = this.annotations; var ele = self._chart.hostElement; var eventListener = bind ? 'addEventListener' : 'removeEventListener'
    //   ele[eventListener]('mousedown', self._hostMouseDown)
    //   ele[eventListener]('mousemove', self._hostMouseMove)
    //   ele[eventListener]('mouseup', self._hostMouseUp)
    //   ele[eventListener]('mouseleave', self._hostMouseLeave)
    // },
    /**
   * Mouse Down event (chart annotation)
   */
    // _onHostMouseDown (e) {
    //   var self = this.annotations; var rootEle = self._chart.hostElement; var anno; var pt = core.mouseToPage(e)
    //   self._originPoint = pt
    //   anno = self._getAnnotation(e.target, rootEle)
    //   if (anno != null) {
    //     this._toggleIsDragging(true, anno)
    //   }
    // },
    /**
   * Mouse Move event (chart annotation)
   */
    // _onHostMouseMove (e) {
    //   var self = this.annotations; var chrt = self._chart; var rootEle = chrt.hostElement; var hostRect; var tarAnno = self._draggingAnno; var newPt
    //   if (self._isDragging) {
    //     newPt = core.mouseToPage(e)
    //     hostRect = core.getElementRect(rootEle.querySelector('svg .wj-plot-area'))
    //     var yPoint = newPt.y - hostRect.top
    //     var yPointPersent = yPoint / hostRect.height * 100
    //     var yMaxVal = chrt.axisY.actualMax
    //     var yMinVal = chrt.axisY.actualMin
    //     // console.log(newPt.y, hostRect.top)
    //     var ySumVal = yMaxVal + Math.abs(yMinVal)
    //     var yVal = ySumVal * (100 - yPointPersent) / 100
    //     if (yPointPersent < 5 || yPointPersent > 95) { return }
    //     switch (tarAnno.name) {
    //       case 'USL':
    //         this.uslVal = Math.round((yVal + yMinVal) * 10000) / 10000.0
    //         break
    //       case 'UCL':
    //         this.uclVal = Math.round((yVal + yMinVal) * 10000) / 10000.0
    //         break
    //       case 'CL':
    //         this.meanVal = Math.round((yVal + yMinVal) * 10000) / 10000.0
    //         break
    //       case 'LCL':
    //         this.lclVal = Math.round((yVal + yMinVal) * 10000) / 10000.0
    //         break
    //       case 'LSL':
    //         this.lslVal = Math.round((yVal + yMinVal) * 10000) / 10000.0
    //         break
    //     }
    //     this.valueChange()
    //   }
    // },
    /**
   * Mouse Up event (chart annotation)
   */
    // _onHostMouseUp (e) {
    //   var self = this.annotations
    //   if (self._isDragging) {
    //     this._toggleIsDragging(false)
    //   }
    // },
    /**
   * Mouse Leave event (chart annotation)
   */
    // _onHostMouseLeave (e) {
    //   this._onHostMouseUp(e)
    // },
    /**
   * Drag Toggling event (chart annotation)
   * @param {Boolean} value drag 인지 아닌지 여부
   * @param {*} anno chart annotation
   */
    // _toggleIsDragging (value, anno) {
    //   var self = this.annotations; var chrt = self._chart
    //   if (value) {
    //     self._isDragging = true
    //     core.addClass(chrt.hostElement, 'no-selection')
    //     if (anno) {
    //       self._draggingAnno = anno
    //     }
    //   } else {
    //     self._isDragging = false
    //     core.removeClass(chrt.hostElement, 'no-selection')
    //     self._draggingAnno = null
    //   }
    // },
    /** Raw Data Grid로 export시 날짜 format 변경해줘야함 */
    // formatGridData (
    //   data = this.itemsSource,
    //   bindingX = this.bindingX,
    //   bindingXType = this.bindingXType
    // ) {
    //   return data.map(item => {
    //     let obj = { ...item }
    //     if (bindingXType === 'DATE') {
    //       let date = _.get(item, bindingX)
    //       let formattedDate = Dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    //       _.set(obj, bindingX, formattedDate)
    //     }
    //     return obj
    //   })
    // }
    formatGridData (chartData) {
      let data = [ ...chartData ]

      data.forEach(row => {
        row['endDt'] = Dayjs(row['endDt']).format('YYYY-MM-DD HH:mm:ss')
      })

      return data
    }
  },
  data () {
    // spec line 스타일 설정
    const lineTemp = {
      type: 'Line',
      position: 0, // Left: = 4
      attachment: 1,
      // tooltip: 'This is a <b>Line</b><br/>annotation',
      tooltip: '',
      style: {
        'fill-opacity': 1,
        'stroke-width': 1,
        'stroke-opacity': 1
      }
    }

    // spec line 스타일 설정
    const textTemp = {
      type: 'Text',
      position: 4,
      attachment: 1,
      // tooltip: 'This is a text annotation.</br>point: { x: 0.55, y: 0.15 }</br> attachment: Relative',
      style: { 'fill': '#bbbbbb', 'font-size': '16px' }
    }

    return {
      palette: [
        'rgba(32, 208, 191, .8)',
        'rgba(47, 141, 250, .8)',
        'rgba(26, 168, 121, .8)',
        'rgba(21, 83, 182, .8)',
        'rgba(248, 199, 83, .8)',
        'rgba(236, 126, 48, .8)',
        'rgba(227, 65, 96, .8)',
        'rgba(189, 65, 227, .8)',
        'rgba(204, 145, 124, .8)',
        'rgba(81, 109, 136, .8)'
      ], // Chart Palette 배열
      uslLine: _.clone(lineTemp),
      uclLine: _.clone(lineTemp),
      mean: _.clone(lineTemp),
      lclLine: _.clone(lineTemp),
      lslLine: _.clone(lineTemp),
      upperSig2Line: _.clone(lineTemp),
      upperSig1Line: _.clone(lineTemp),
      lowerSig1Line: _.clone(lineTemp),
      lowerSig2Line: _.clone(lineTemp),
      upperSig2Text: _.clone(textTemp), // LSL Text Annotation 설정
      upperSig1Text: _.clone(textTemp), // LSL Text Annotation 설정
      lowerSig1Text: _.clone(textTemp), // LSL Text Annotation 설정
      lowerSig2Text: _.clone(textTemp), // LSL Text Annotation 설정
      annotations: null,
      annotationItems: [],
      sigma: null,
      weight: 1.0,
      meanVal: null,
      stdevVal: null,
      uslVal: null,
      sigUsl: 6,
      uclVal: null,
      sigUcl: 3,
      clVal: null,
      lclVal: null,
      sigLcl: 3,
      lslVal: null,
      sigLsl: 6,
      yMin: null,
      yMax: null,
      chartData: [],
      orgChartData: [],
      selectLotsModal: {
        visible: false
      },
      selectedLots: [],
      selectedTreeNode: [],
      selectedModelData: [],
      selectedModelRuleData: {},
      lotStepYn: 'N',
      outlierYn: 'N',
      selectedRules: [],
      totalSampleCount: 0,
      targetMean: 0,
      simulationData: [],
      upperOutlier: null,
      lowerOutlier: null,
      orgAutoSpecData: [],
      rawExcelData: [],
      rawExcelDataColumns: [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 60 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 80 },
        { headerName: this.$t('fdc.SPC.COLUMN.PARAM_ALIAS'), field: 'paramAlias', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 65 },
        { headerName: this.$t('fdc.SPC.COLUMN.SMRY_TYPE'), field: 'smryType', width: 120 },
        { headerName: this.$t('fdc.SPC.COLUMN.END_DT'), field: 'endDt', width: 120, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', width: 120 },
        { headerName: this.$t('fdc.SPC.COLUMN.VALUE'), field: 'paramValue', width: 120, type: 'numericColumn', valueFormatter: data => data.value.toFixed(10) },
        { headerName: this.$t('fdc.COMMON.COLUMN.USL'), field: 'uslVal', width: 120, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.UCL'), field: 'uclVal', width: 120, type: 'numericColumn' },
        { headerName: this.$t('fdc.SPC.COLUMN.CL_VAL'), field: 'clVal', width: 120, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.LCL'), field: 'lclVal', width: 120, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.LSL'), field: 'lslVal', width: 120, type: 'numericColumn' },
        { headerName: this.$t('fdc.SPC.COLUMN.FAULT_RULE_NO'), field: 'oocRuleList', width: 120 }
      ],
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      breadcrumbs: null,
      upperSig2: null,
      upperSig1: null,
      lowerSig1: null,
      lowerSig2: null,
      sigmaLineYn: false,
      endDtYn: false
      // selectedTab: 0
    }
  }
}
